<template>
  <a-select
    v-model="selected_code"
    :placeholder="$t('单据类型')"
    :disabled="disabled"
    style="width: 100%"
    :allow-clear="allowClear"
    @change="handleChange"
  >
    <a-select-option v-for="item in list" :key="item.code" :value="item.code">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
export default {
  name: 'SelectDocumentType',
  model: {
    prop: 'code',
    event: 'update:code',
  },
  props: {
    // 当前单据的 docType，如 ReceiptNote / PayableOrder / ReceivableOrder 等
    docType: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    selected_code: {
      get() {
        return this.code
      },
      set(val) {
        this.$emit('update:code', val)
      },
    },
  },
  watch: {
    docType: {
      handler(val) {
        console.log('val', val)
        if (val) {
          this.fetchList()
        }
      },
      immediate: true,
    },
  },
  methods: {
    async fetchList() {
      try {
        const fieldRes = await http({
          url: api.getFinanceDocumentFieldValue,
          data: {
            financeDocumentCode: this.docType,
            fieldCode: `${this.docType}.orderType`,
          },
        })
        if (fieldRes.result?.length > 0) {
          this.list = fieldRes.result.map((item) => ({
            code: item.value_code,
            name: item.value_name,
          }))
          return
        }
      } catch (e) {
        console.error('获取自定义单据类型失败', e)
      }
    },
    handleChange(val) {
      this.$emit('change', val)
    },
  },
}
</script>
